module.exports = {
      id: "AppHeaderNormal-usage",
      viewBox: "0 0 544 152",
      url: __webpack_public_path__ + "images/js_src_vue/common/sprite.61ac148b.svg#AppHeaderNormal-usage",
      toString: function () {
        return this.url;
      }
    }